import React, { FunctionComponent } from "react"

interface ProgressBarProps {
	max: number
	current: number
}

const ProgressBar: FunctionComponent<ProgressBarProps> = ({ max, current }) => {
	const percentage = Math.min((current / max) * 100, 100)

	return (
		<div className='progress-cont'>
			<div
				className='progress-bar-fill'
				style={{
					width: `${percentage}%`
				}}
			/>
		</div>
	)
}

export default ProgressBar
